import React, { Component } from 'react'
import {ethers} from "ethers"
import { firestore } from "./Firebase";
import { doc, setDoc, getDoc, collection, getDocs } from "firebase/firestore"; 

const ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_candidateName",
        "type": "string"
      }
    ],
    "name": "addCandidate",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_candidateName",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_voterName",
        "type": "string"
      }
    ],
    "name": "doVote",
    "outputs": [
      {
        "internalType": "string",
        "name": "err",
        "type": "string"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getWinner",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalCandidates",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalVotes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "winningCandidateName",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "winningVoteCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export default class Dashboard extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      ContractAddressState : null,
      Caddress:'',
      candidateName :'',
      partyName :'',
      provider : null,
      contract : null,
      signer : null,
      winner: null,
      WinnerLoading: null,
      fill1:false,
      fill2:false,
      fill3:false,
    }
  }
  validateFields = () => {
    let error = false;
    if(this.state.candidateName===''){
      error = true;
      this.setState({
        fill1:true
      })
    }else{
      this.setState({
        fill1:false
      })
    }
    if(this.state.partyName===''){
      error = true;
      this.setState({
        fill2:true
      })
    }else{
      this.setState({
        fill2:false
      })
    }
    return error
  }
  validateAddress = () => {
    let error = false;
    if(this.state.Caddress===''){
      error = true;
      this.setState({
        fill3:true
      })
    }else{
      this.setState({
        fill3:false
      })
    }
    return error
  }

  handleStartVote = async(e)=>{
    e.preventDefault();
    const AddressValidation = await this.validateAddress();
    if(!this.state.fill3 && !AddressValidation){
      const contractAddress = this.state.Caddress;
      const contractABI = ABI;
      try{
          const {ethereum} = window;
          if(ethereum){
              await ethereum.request({method:"eth_requestAccounts",});
          }
          const provider = new ethers.providers.Web3Provider(ethereum); 
          const signer = provider.getSigner();
          const contract = new ethers.Contract(contractAddress,contractABI,signer);
          this.setState({
              provider: provider,
              contract: contract,
              signer : signer,
              ContractAddressState : contractAddress
          })
          console.log(this.state.contract)
          
      }catch(error){
          console.log(error);
      };
      await setDoc(doc(firestore, "Contract", "Address"), {
        ContractAddress: this.state.Caddress
      });
    }
  }

  handleEndVote=async(e)=>{
    e.preventDefault();
    this.setState({
      Caddress:'',
      provider:null,
      contract:null,
      signer:null,
      ContractAddressState : null,
    })
    await setDoc(doc(firestore, "Contract", "Address"), {
      ContractAddress: '',
    });
    //TO DO ---> After ending vote all users vote status should be reset to false
  }

  handleAddCandidate=async(e)=>{
    e.preventDefault();
    const validation = await this.validateFields();
    if(!this.state.fill1 && !this.state.fill2 && !validation){
      if(this.state.contract !== null){
        await setDoc(doc(firestore, "CandidatesInfo", this.state.candidateName), {
          CandidateName: this.state.candidateName,
          PartyName: this.state.partyName
        });
        console.log('Candidate Successfully Added to Firebase')
  
        const transaction = await this.state.contract.addCandidate(this.state.candidateName);
        await transaction.wait();
        console.log('Candidate Successfully Added')
        alert('Candidate Successfully Added')
        this.setState({
          candidateName: '',
          partyName:'',
        })
      }else{
        alert('No Contract currently Deployed')
      }
    }
  }

  handleGetWinner = async(e)=>{
    e.preventDefault();
    let Caddr = this.state.ContractAddressState
    if(Caddr===null || Caddr === ''){
      alert('No Contract currently Deployed')
    }
    const contractAddress = Caddr;
    const contractABI = ABI;
    try{
        const {ethereum} = window;
        if(ethereum){
            await ethereum.request({method:"eth_requestAccounts",});
        }
        const provider = new ethers.providers.Web3Provider(ethereum); 
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress,contractABI,signer);

        this.setState({
            WinnerLoading:false
        })
        const winner = await contract.getWinner();
        console.log('winner fetched successfully')
        alert('winner fetched successfully')
        this.setState({
          winner:winner,
          WinnerLoading:true,
        })
    }catch(error){
        console.log(error);
    };
  }

  componentDidMount(){
    const GetContractAddress = async () => {
      const docSnap = await getDoc(doc(firestore, "Contract", "Address"));
      const ContractAddressState = docSnap.data().ContractAddress
      if(ContractAddressState !== ''){
        this.setState({
          ContractAddressState: ContractAddressState,
        })
      }
    }
    GetContractAddress();
  }

  render() {
    const {fill1,fill2} = this.state
    return (
      <div className='Dasboard'>
        <h1>DASHBOARD</h1>
        <div className='DashForms'>
          <form>
            <h2>Enter Contract Address</h2>
            <div className='DashInputs'>
              <input type='text' placeholder='Contract Address' value={this.state.Caddress} onChange={(e)=>{this.setState({Caddress:e.target.value})}}></input>
              {this.state.fill3?<span className='Warnings'>Please enter Contract Address</span>:""}
            </div>
            <div>
              <button onClick={(e)=>this.handleStartVote(e)}>Start Voting</button>
              <button onClick={(e)=>this.handleEndVote(e)}>End Voting</button>
            </div>
            {this.state.ContractAddressState !== null ?<span>Current Deployed Contract : {this.state.ContractAddressState}</span>: <></>}
          </form>
          <form>
            <h2>Enter Candidate's Details</h2>
            <div className='DashInputs'>
              <input type='text' placeholder='Candidate Name' value={this.state.candidateName} onChange={(e)=>{this.setState({candidateName:e.target.value})}}></input>
              {fill1?<span className='Warnings'>Please enter Candidate Name</span>:""}
            </div>
            <div className='DashInputs'>
              <input type='text' placeholder='Party Name' value={this.state.partyName} onChange={(e)=>{this.setState({partyName:e.target.value})}}></input>
              {fill2?<span className='Warnings'>Please enter Candidate's Party Name</span>:""}
            </div>
            <button onClick={(e)=>this.handleAddCandidate(e)}>Add Candidate</button>
          </form>
        </div>
        <div className='DashWinner'>{this.state.WinnerLoading === null ? <button onClick={(e)=>this.handleGetWinner(e)}>Get Winner</button>:<>{this.state.WinnerLoading === false?<h3>....Loading</h3>:<h3>{this.state.winner}</h3>}</>}</div>
      </div>
    )
  }
}
